// Produto simples (sem combo/etapas): preço, observação e quantidade.
import { fmt } from "../../lib/helpers";
import ControleQuantidade from "./ControleQuantidade";

export default function ProdutoSimples({ h }) {
  const { comboPrice, simplePricePromo, observation, setObservation } = h;
  const temPromo = simplePricePromo != null && simplePricePromo !== comboPrice;
  return (
    <div className="max-w-4xl space-y-6" data-e2e="produto-simples">
      <div className="flex items-baseline gap-3">
        {temPromo && <span className="text-2xl line-through text-zinc-500">R$ {fmt(comboPrice)}</span>}
        <span className={`text-4xl font-black ${temPromo ? "text-green-500" : "text-primary"}`} data-e2e="produto-preco">R$ {fmt(temPromo ? simplePricePromo : comboPrice)}</span>
      </div>
      <div>
        <label className="text-sm font-medium mb-2 block text-zinc-300">Observação (opcional)</label>
        <textarea value={observation} onChange={(e) => setObservation(e.target.value)} placeholder="Ex: sem cebola, molho à parte..." rows={2} className="w-full resize-none rounded-xl bg-zinc-900 border border-zinc-700 text-zinc-100 p-3 text-base focus:outline-none focus:border-primary" />
      </div>
      <ControleQuantidade h={h} />
    </div>
  );
}
